import React, { useState } from 'react';
import PropTypes from "prop-types";
import { Modal, Button, Checkbox, noop } from 'rhombus-react';

import { useTooltipRebuild } from 'hooks/useTooltipRebuild';
import { approvalBooleans } from 'utils/CreativeActions';

const { isQA, isApproved } = approvalBooleans;

export default function SingleFileModal(props) {
	const {
		filename,
		approval,

		title,

		canApplyToAll,

		onSkip,
		onRename,
		onOverwrite,
		onCancel,
	} = props;
	useTooltipRebuild();
	const [applyToAll, setApplyToAll] = useState(false);

	const canOverwrite = !isQA(approval) && !isApproved(approval);

	function renderContent(){
		const overwriteText = canOverwrite ? "Do you want to overwrite it with the one you are uploading?"  : "It cannot be overwritten because the current creative status is approved.";
		return (
			<div className="c-modal-body">
				<p className="error-msg center">
					A creative file named <span className="creative-name"><q><b>{filename}</b></q></span> already exists in your library. {overwriteText}
				</p>
			</div>
		);
	}

	function renderFooter(){
		let tip;

		if (!canOverwrite) {
			tip = "Cannot overwrite because the current creative is in an approved status";
		}

		return (
			<>
				<Button onClick={onCancel} theme="default">Cancel Upload</Button>
				<div className="actions-container">
					{
						canApplyToAll && (
							<Checkbox
								checked={applyToAll}
								onChange={(e) => { setApplyToAll(e.currentTarget.checked); }}
								label="Apply to All"
							/>
						)
					}
					<Button onClick={() => onSkip(applyToAll)}>Skip</Button>
					<Button onClick={() => onRename(applyToAll)}>Rename</Button>
					<div className="overwrite-tip" data-tip={tip}>
						<Button
							onClick={() => onOverwrite(applyToAll)}
							theme="red"
							disabled={!canOverwrite}
						>
							Overwrite Creative
						</Button>
					</div>
				</div>
			</>
		);
	}

	let modalProps = {
		type: "modal",
		title,
		allowFullScreen: false,
		className: "creative-upload-error-modal single-file-modal",
		xClose: false,
		setAppTitle: false,
		bladeProps: {
			verticallyCenter: true,
			initialFocus: "p", /*
				If we don't set initialFocus to something, it will auto focus one of the preview
				links, which the user might open by accident by hitting enter.

				After the user attempts to upload, this modal may pop up while they're in the middle
				of doing something else, so we set a value here that won't actually focus anything.
			*/
		},
		renderContent,
		renderFooter,
	};

	return <Modal {...modalProps} />;
}

SingleFileModal.displayName = "SingleFileModal";

SingleFileModal.propTypes = {
	filename: PropTypes.string.isRequired,
	approval: PropTypes.string.isRequired,

	title: PropTypes.string,

	canApplyToAll: PropTypes.bool,

	onSkip: PropTypes.func,
	onRename: PropTypes.func,
	onOverwrite: PropTypes.func,
	onCancel: PropTypes.func,
};

SingleFileModal.defaultProps = {
	title: "Upload Creative Error",

	canApplyToAll: false,

	onSkip: noop,
	onRename: noop,
	onOverwrite: noop,
	onCancel: noop,
};
